// Eine Zeile der Statistik-Liste: kleiner Prozent-Ring, Name, "X von Y
// Kennzeichen gesehen" (IMG_4884 bis 4888, 01.09.2026). Anders als der
// grosse Ring auf dem Hauptscreen (bausteine/Ring.tsx) traegt dieser nur
// die Prozentzahl, kein Icon.

const RADIUS = 20;
const UMFANG = 2 * Math.PI * RADIUS;

export function RingZeile({ name, gesehen, gesamt }: { name: string; gesehen: number; gesamt: number }) {
  const anteil = gesamt > 0 ? gesehen / gesamt : 0;
  const versatz = UMFANG * (1 - anteil);

  return (
    <div className="flex items-center gap-4 border-t border-neutral-100 px-4 py-3 first:border-t-0">
      <div className="relative flex h-12 w-12 shrink-0 items-center justify-center">
        <svg viewBox="0 0 48 48" className="absolute inset-0 -rotate-90">
          <circle cx="24" cy="24" r={RADIUS} fill="none" stroke="#DFECDF" strokeWidth="4" />
          <circle
            cx="24"
            cy="24"
            r={RADIUS}
            fill="none"
            stroke="#43A047"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray={UMFANG}
            strokeDashoffset={versatz}
          />
        </svg>
        <span className="text-xs font-medium">{Math.round(anteil * 100)}%</span>
      </div>
      <div>
        <div className="text-base">{name}</div>
        <div className="text-sm text-neutral-500">
          {gesehen} von {gesamt} Kennzeichen gesehen
        </div>
      </div>
    </div>
  );
}
